import { Component, Input } from '@angular/core';

@Component({
  selector: 'vfs-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() show: boolean;
  @Input() opaque = true;
  // Align parameters
  @Input() position: string = 'fixed';
  @Input() left: number;
  @Input() right: number;
  @Input() bottom: number;
  @Input() top: number;
  // Size parameters in %
  @Input() width: number;
  @Input() height: number;
}
